/* eslint-disable import/extensions */
import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import {
  lighten,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@material-ui/core';
import { useTranslation } from 'next-i18next';
import { FinancialsType } from 'typings/markets/api';
import useMoneyFormat from '@/hooks/useMoneyFormat';
import Spacer from '@/components/ui-components/Spacer';
import Typography from '../../components/Typography';

const useStyles = makeStyles((theme) => ({
  header: {
    backgroundColor: lighten(theme.palette.primary.light, 0.8),
    '&>td': {
      borderRadius: '12px',
    },
  },
  subheader: {
    backgroundColor: lighten(theme.palette.primary.light, 0.9),
  },
  negative: {
    color: theme.palette.negative.main,
  },
}));

interface Props {
  item: FinancialsType;
}

const defaultProps = {};

const negativeNumber = (n: string | number | null) => {
  if (typeof n === 'number') {
    if (n < 0) {
      return true;
    }
  }
  return false;
};
const Financials = ({ item }: Props) => {
  const classes = useStyles();
  const { t } = useTranslation('markets');
  return (
    <>
      <Typography variant="header">
        {t('markets.detailView.financials.title')}
      </Typography>
      <Spacer spacing={2} />
      <TableContainer>
        <Table aira-label="FinancialsTable">
          <TableHead className={classes.header}>
            <TableRow>
              <TableCell>
                <Typography variant="baseBold">
                  {t('markets.detailView.financials.title')}
                </Typography>
              </TableCell>
              {item.years?.map((year) => (
                <TableCell key={year}>
                  <Typography variant="baseBold" align="right">
                    {year}
                  </Typography>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {item.contents?.map((rows) => (
              <>
                <TableRow key={rows.title} className={classes.subheader}>
                  <TableCell size="small" colSpan={item.years.length + 1}>
                    <Typography variant="baseBold">{t(`markets.detailView.financials.${rows.title}` as const)}</Typography>
                  </TableCell>
                </TableRow>
                {rows.contents.map((row) => (
                  <TableRow key={row.title}>
                    <TableCell>
                      <Typography
                        variant={row.isTotal ? 'secondary2bold' : 'secondary2'}
                      >
                        {t(`markets.detailView.financials.${row.title}` as const)}
                      </Typography>
                    </TableCell>

                    {row.values.map((value) => (
                      <TableCell size="small" key={value}>
                        <Typography
                          align="right"
                          variant={
                            row.isTotal ? 'secondary2bold' : 'secondary2'
                          }
                          className={
                            negativeNumber(value) ? classes.negative : undefined
                          }
                        >
                          {useMoneyFormat(
                            value,
                            'en-US',
                            'USD',
                            'currency',
                            'symbol',
                            0,
                            2,
                          )}
                        </Typography>
                      </TableCell>
                    ))}
                  </TableRow>
                ))}
              </>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

Financials.defaultProps = (defaultProps as unknown) as Partial<Props>;

export default Financials;
